import { mockQuoteEligibilityParameters } from '@domgen/dgx-fe-basket';
import { SelectedQuotesIneligibilityModalData } from '../../models/selected-quotes-ineligibility-modal/selected-quotes-ineligibility-modal-data.interface';

export const mockSelectedQuotesIneligibilityModalData: SelectedQuotesIneligibilityModalData =
  {
    quoteEligibilityParameters: mockQuoteEligibilityParameters,
  };
